export enum TrailerAssessmentOutcome {
    VIRTUAL_RED_TAG = 'Virtual Red Tag',
    TOOK_POSSESSION = 'Took Possession',
    DECLINED_DUE_TO_DOT_EXPIRATION = 'Declined Due to DOT Expiration',
    DECLINED_POSSESSION = 'Declined Possession',
    UNSPECIFIED = 'Unspecified',
}
